import { render, staticRenderFns } from "./RegraFiscal.vue?vue&type=template&id=4518b6c0"
import script from "./RegraFiscal.vue?vue&type=script&lang=js"
export * from "./RegraFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports